import React from "react";
import './Fauna.css';
import Navbutton from "../navbutton/Navbutton";
import SiYourtraveldottv from "../image/SiYourtraveldottv.png";
import fundofolha from "../image/fundofolha.jpg";
import d1 from "./img/dig1.jpg";
import d2 from "./img/dig2.jpg";
import d3 from "./img/dig3.jpg";
import Header from "../components/Header";

const Digital = () => {
  
    const handleGoBack = () => {
      window.history.back(); // Volta à página anterior
    };

  return (
    <div className="fauna-container">
        <Header/>
    <div className="fauna-header">
      <h1>Desenvolvimento de Soluções Digitais</h1>
      <p>A Biolink conta com uma equipe especializada no desenvolvimento de soluções digitais voltadas para o setor ambiental.</p>
    </div>
    <div className="conteudo-grid">
            <div className="conteudo-card">
              <img
                src={d1}
                alt="Laudo Técnico"
                style={{
                  width: "100%", // Largura total do card
                  height: "auto", // Proporção da imagem
                  objectFit: "cover", // Ajusta a imagem para preencher o espaço
                }}
              />
    
              <h3>Aplicativos para Coleta de Dados</h3>
              <p>
              Desenvolvemos aplicativos personalizados para coleta de dados em campo, otimizando a eficiência e precisão das informações ambientais.
              </p>
            </div>
    
      <div className="conteudo-card">
              <img
                src={d2}
                alt="Laudo Técnico"
                style={{
                  width: "100%", // Largura total do card
                  height: "auto", // Proporção da imagem
                  objectFit: "cover", // Ajusta a imagem para preencher o espaço
                }}
              />
    
              <h3>Sistemas para Gestão Digital de Projetos</h3>
              <p>
              Nossas soluções utilizam tecnologias avançadas para otimizar a eficiência dos projetos, facilitar a tomada de decisão e garantir a integração de dados de forma prática e acessível. 
              </p>
            </div>


     <div className="conteudo-card">
              <img
                src={d3}
                alt="Laudo Técnico"
                style={{
                  width: "100%", // Largura total do card
                  height: "auto", // Proporção da imagem
                  objectFit: "cover", // Ajusta a imagem para preencher o espaço
                }}
              />
        <h3> Automação de Processos Ambientais </h3>
        <p>Desenvolvemos sistemas para automatizar processos, como emissão de relatórios, gestão de licenças e monitoramento de conformidade ambiental.</p>
      </div>

    </div>
    <div className="back-button-container">
    <button onClick={handleGoBack} className="back-button"   > <i class=" fas fa-solid fa-arrow-left"></i>
      Voltar
    </button>
  </div>
  <section class="footer" style={{
   background: `linear-gradient(rgba(255, 255, 255, 0.5), rgba(138, 138, 138, 0.5)), url(${fundofolha})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    
    
    color: "#fff" // Para contrastar o texto com o fundo
  }}>
        <div class="box-container">
          <div class="box">
            <h3>Navegue</h3>
            <a href="#">
              {" "}
              <i class="fas fa-chevron-right"></i> Início{" "}
            </a>
            <a href="#">
              {" "}
              <i class="fas fa-chevron-right"></i> Sobre{" "}
            </a>
            <a href="#">
              {" "}
              <i class="fas fa-chevron-right"></i> Serviços{" "}
            </a>
            <a href="#">
              {" "}
              <i class="fas fa-chevron-right"></i> Equipe{" "}
            </a>
            <a href="#">
              {" "}
              <i class="fas fa-chevron-right"></i> Iniciar conversa{" "}
            </a>
            <a href="#">
              {" "}
              <i class="fas fa-chevron-right"></i> Avaliações{" "}
            </a>
            <a href="#">
              {" "}
              <i class="fas fa-chevron-right"></i> Blog{" "}
            </a>
          </div>

          <div class="box">
            <h3>Nossos serviços</h3>
            <a href="#">
              {" "}
              <i class="fas fa-chevron-right"></i> Florestal{" "}
            </a>
            <a href="#">
              {" "}
              <i class="fas fa-chevron-right"></i>  Fauna{" "}
            </a>
            <a href="#">
              {" "}
              <i class="fas fa-chevron-right"></i> Propriedade Intelectual{" "}
            </a>
            <a href="#">
              {" "}
              <i class="fas fa-chevron-right"></i> Laudos e Pareceres Técnicos{" "}
            </a>
            <a href="#">
              {" "}
              <i class="fas fa-chevron-right"></i> Levantamentos{" "}
            </a>
          </div>

          <div class="box">
            <h3>Contato </h3>
            <a href="#">
              {" "}
              <i class="fas fa-phone"></i> (34) 9 9920-3789{" "}
            </a>
            <a href="#">
              {" "}
              <i class="fas fa-phone"></i> (11) 9 8632-1639{" "}
            </a>
            <a href="#">
              {" "}
              <i class="fas fa-envelope"></i> emerson@biolinksolucoes.com.br{" "}
            </a>
            <a href="#">
              {" "}
              <i class="fas fa-envelope"></i> omar.neto@biolinksolucoes.com.br{" "}
            </a>
            <a href="#">
              {" "}
              <i class="fas fa-map-marker-alt"></i> Uberlândia, Minas Gerais {" "}
            </a>
          </div>

          <div class="box">
            <h3>Conecte-se conosco!</h3>
            <a href="#">
              {" "}
              <i class="fab fa-facebook-f"></i> facebook{" "}
            </a>
          
            <a href="#">
              {" "}
              <i class="fab fa-instagram"></i> instagram{" "}
            </a>
            <a href="#">
              {" "}
              <i class="fab fa-linkedin"></i> linkedin{" "}
            </a>
           
          </div>
        </div>

        <div class="credit">
          {" "}
          Criado por{" "}
          <span>
            <a href="https://instagram.com"> Biolink </a>
          </span>{" "}
          | ©Todos os direitos reservados.{" "}
        </div>
      </section>
  </div>
  );
};

export default Digital;